document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector('.text-video-section');
  if (!section) return;

  const playButton = section.querySelector('.play');
  const video = section.querySelector('video');

  if (playButton && video) {
    playButton.addEventListener('click', () => {
      video.controls = true;
      video.play();
      playButton.style.display = 'none';
    });
  }
});